





































import { mixins } from 'vue-class-component'
import { Component, Prop, Emit, Watch } from 'vue-property-decorator'
import { showErrors, showNotification } from '@/utils/snack'
import { SnackType } from '@/interfaces/snack'
import AppDialog from '@/components/AppDialog.vue'
import AppSteps from '@/components/AppSteps.vue'
import PolicyFormInfo from '@/modules/Policy/components/forms/PolicyFormInfo.vue'
import PolicyFormAdditional from '@/modules/Policy/components/forms/PolicyFormAdditional.vue'
import PolicyFormPremium from '@/modules/Policy/components/forms/PolicyFormPremium.vue'
import EndorsementFormNote from '@/modules/Policy/components/forms/EndorsementFormNote.vue'
import { Policy } from '@/modules/Policy/interfaces/policy'
import RecordTypesHandler from '@/mixins/record-types'
import { newEndorsement } from '@/modules/Policy/gql/endorsement.gql'
import { IPolicyInfoInput, IPolicyAdditionalInfoInput, IPolicyPremiumInput, IEndorsementNoteInput } from '@/modules/Policy/interfaces/policy-form'
import { statusKeys, policyTypeKeys, billingTypeKeys, payerTypeKeys, payerType } from '@/modules/Policy/helpers/policy'

@Component({
  components: {
    PolicyFormInfo,
    AppDialog,
    PolicyFormAdditional,
    PolicyFormPremium,
    AppSteps,
    EndorsementFormNote
  }
})
export default class EndorsementForm extends mixins(RecordTypesHandler) {
  @Prop(Boolean) value!: boolean
  @Prop(Number) readonly step!: number
  @Prop(String) readonly title!: string
  @Prop({ type: Object as () => Policy }) readonly policy!: Policy

  showDialog = false
  loading = false
  showEndorsementNote = false

  recordTypeIndex = 0
  stepIndex = 0
  steps = [
    ['Policy Info', 770, 591],
    ['Premium Info', 770, 940],
    ['Additional Info', 770, 561],
    ['Notes', 770, 321]
  ]

  infoInput: IPolicyInfoInput = {
    policyName: '',
    policyNumber: '',
    typeIdx: -1,
    statusIdx: -1,
    quote: {},
    priorTerm: {},
    originalInceptionDate: '',
    cancelDate: '',
    nonRenew: false,
    writingAgent: {}
  }

  premiumInput: IPolicyPremiumInput = {
    effectiveDate: '',
    expirationDate: '',
    bindDate: '',
    term: 0,
    premium: '0',
    agencyFee: '0',
    carrierPolicyFee: '0',
    inspectionFee: '0',
    stampingFee: '0',
    taxesFee: '0',
    brokerFee: '0',
    billingTypeIdx: 0,
    commission: '0',
    installmentPlan: 1,
    payerTypeIdx: 0
  }

  additionalInfoInput: IPolicyAdditionalInfoInput = {}

  noteInput: IEndorsementNoteInput = {
    notes: ''
  }

  get stepItems () {
    return this.steps.map(st => st[0])
  }

  get hightLightTitle () {
    return this.policy ? ' (' + this.policy.policyName + ')' : ''
  }

  get showBackBtn () {
    return this.stepIndex > 0
  }

  get confirmText () {
    return this.stepIndex < this.steps.length - 1
      ? 'Next'
      : 'Create'
  }

  get confirmAheadText () {
    return 'Create'
  }

  get canPost () {
    return true
  }

  @Watch('value')
  onValueChanged (val: boolean) {
    if (val) {
      this.resetStep()
      this.initInput()
    }
    this.showDialog = val
  }

  resetStep () {
    this.stepIndex = this.step
  }

  initInput () {
    if (this.policy) {
      const {
        policyName, type, status, originalInceptionDate,
        policyNumber, additionalInfoStr, cancelDate, nonRenew,
        effectiveDate, expirationDate, bindDate,
        installmentPlan,
        billingType, term, premium, agencyFee, brokerFee, carrierPolicyFee, inspectionFee, taxesFee, stampingFee, productCommissionOverride, insuranceQuote,
        writingAgents, payerType,
        inheritPolicies: {
          fromPolicy
        }
      } = this.policy
      this.infoInput = {
        policyName,
        policyNumber,
        quote: {
          id: insuranceQuote ? +insuranceQuote.id : undefined,
          name: insuranceQuote ? insuranceQuote.name : ''
        },
        cancelDate: cancelDate ? cancelDate + '' : '',
        nonRenew,
        typeIdx: policyTypeKeys.findIndex(key => key === type),
        statusIdx: statusKeys.findIndex(key => key === status),
        priorTerm: {
          id: fromPolicy ? +fromPolicy.id : undefined,
          name: fromPolicy ? fromPolicy.policyName : ''
        },
        originalInceptionDate: originalInceptionDate ? originalInceptionDate + '' : '',
        writingAgent: {
          id: writingAgents.length ? +writingAgents[0].id : undefined,
          name: writingAgents.length ? writingAgents[0].username : ''
        }
      }
      this.premiumInput = {
        effectiveDate: effectiveDate ? effectiveDate + '' : '',
        expirationDate: expirationDate ? expirationDate + '' : '',
        bindDate: bindDate ? bindDate + '' : '',
        term: term || 1,
        premium: premium || '0',
        agencyFee: agencyFee || '0',
        carrierPolicyFee: carrierPolicyFee || '0',
        inspectionFee: inspectionFee || '0',
        stampingFee: stampingFee || '0',
        taxesFee: taxesFee || '0',
        brokerFee: brokerFee || '0',
        billingTypeIdx: billingTypeKeys.findIndex(key => key === billingType),
        payerTypeIdx: payerTypeKeys.findIndex(key => key === payerType),
        commission: productCommissionOverride ? productCommissionOverride + '' : '0',
        installmentPlan: installmentPlan || 1
      }
      const additionalInfo = JSON.parse(additionalInfoStr)
      this.additionalInfoInput = { ...additionalInfo }
    } else {
      this.clearForm()
    }
  }

  handleStepClick (index: number) {
    if (!this.policy) {
      return
    }

    const pass = this.handleValidate()
    if (!pass) {
      return
    }

    this.stepIndex = index
  }

  handleValidate () {
    const { stepIndex, steps } = this
    const refName = steps[stepIndex][0] as string
    return (this.$refs[refName] as Vue & {
      validate: () => null | { [key: string]: number | string }
    }).validate()
  }

  handleConfirm (event: Event, finishAhead = false) {
    if (this.showEndorsementNote) {
      this.showEndorsementNote = false
      this.showDialog = true
      return
    }
    const pass = this.handleValidate()
    if (!pass) {
      return
    }

    if (this.stepIndex === this.steps.length - 1 || finishAhead) {
      this.loading = true
      this.handleEndorse()
    } else {
      this.stepIndex += 1
    }
  }

  handleBack () {
    if (this.stepIndex > 0) {
      this.stepIndex -= 1
    } else {
      this.showDialog = false
      this.showEndorsementNote = true
    }
  }

  async handleEndorse () {
    const {
      infoInput: {
        policyName, policyNumber, typeIdx, statusIdx,
        priorTerm: { id: priorTermId },
        originalInceptionDate,
        quote: { id: quoteId },
        cancelDate, nonRenew,
        writingAgent: { id: writingAgentId }
      },
      premiumInput: {
        term, installmentPlan,
        effectiveDate, expirationDate,
        premium, agencyFee, carrierPolicyFee, inspectionFee, stampingFee, brokerFee, taxesFee, commission, billingTypeIdx
      },
      noteInput: {
        notes
      },
      policy
    } = this

    try {
      const res = await this.$apollo.mutate({
        mutation: newEndorsement,
        variables: {
          policyId: +this.policy.id,
          note: notes,
          input: {
            policyName,
            policyNumber,
            status: statusKeys[statusIdx],
            type: policyTypeKeys[typeIdx],
            effectiveDate: effectiveDate ? effectiveDate + '' : null,
            expirationDate: expirationDate ? expirationDate + '' : null,
            originalInceptionDate: originalInceptionDate ? originalInceptionDate + '' : null,
            cancelDate: cancelDate ? cancelDate + '' : null,
            insuranceQuoteId: quoteId || null,
            nonRenew,
            additionalInfoStr: this.parseAdditionalInfo(),
            recordTypeId: +policy.recordType.id,
            accountId: +policy.account.id,
            primaryContactId: policy.primaryContact ? +policy.primaryContact.id : null,
            sourceId: policy.source ? +policy.source.id : null,
            carrierProductId: policy.carrierProduct ? +policy.carrierProduct.id : null,
            priorTermId: priorTermId || null,
            bookId: policy.book ? +policy.book.id : null,
            carrierId: policy.carrier ? +policy.carrier.id : null,
            gaId: policy.generalAgent ? +policy.generalAgent.id : null,
            caseId: +policy.caseId || null,
            premium: premium ? +premium : 0,
            agencyFee: agencyFee ? +agencyFee : 0,
            carrierPolicyFee: carrierPolicyFee ? +carrierPolicyFee : 0,
            inspectionFee: inspectionFee ? +inspectionFee : 0,
            stampingFee: stampingFee ? +stampingFee : 0,
            brokerFee: brokerFee ? +brokerFee : 0,
            taxesFee: taxesFee ? +taxesFee : 0,
            writingAgentIds: writingAgentId ? [+writingAgentId] : null,
            productCommissionOverride: commission ? +commission : 0,
            term: term ? Number(term) : null,
            billingType: billingTypeKeys[billingTypeIdx],
            installmentPlan: installmentPlan ? Number(installmentPlan) : null
          }
        }
      })
      this.clearForm()
      this.onSuccess('Update policy successfully')
    } catch (e) {
      this.loading = false
      showErrors(e.graphQLErrors)
    }
  }

  parseAdditionalInfo () {
    return JSON.stringify(this.additionalInfoInput, (key, value) => {
      return value === 0 ? '0' : (value || '')
    })
  }

  clearForm () {
    this.loading = false

    this.infoInput = {
      policyName: '',
      policyNumber: '',
      typeIdx: -1,
      statusIdx: -1,
      quote: {},
      priorTerm: {},
      originalInceptionDate: '',
      cancelDate: '',
      nonRenew: false,
      writingAgent: {}
    }

    this.premiumInput = {
      effectiveDate: '',
      expirationDate: '',
      bindDate: '',
      term: 0,
      premium: '0',
      agencyFee: '0',
      carrierPolicyFee: '0',
      inspectionFee: '0',
      stampingFee: '0',
      taxesFee: '0',
      brokerFee: '0',
      billingTypeIdx: 0,
      commission: '0',
      installmentPlan: 1,
      payerTypeIdx: 0
    }

    this.additionalInput = {}

    this.noteInput = {
      notes: ''
    }
  }

  @Emit('cancel')
  handleCancel () {
    this.$emit('input', false)
    this.clearForm()
  }

  @Emit('success')
  onSuccess (msg = '') {
    this.$emit('input', false)
    this.resetStep()
    if (msg) {
      showNotification({
        msg,
        type: SnackType.Success
      })
    }
  }
}
